import { getFeatureFlagsApi, updateFeatureFlagsApi } from '../util/api';

// ================ Action types ================ //

export const FETCH_FEATURE_FLAGS_REQUEST = 'app/featureFlags/FETCH_FEATURE_FLAGS_REQUEST';
export const FETCH_FEATURE_FLAGS_SUCCESS = 'app/featureFlags/FETCH_FEATURE_FLAGS_SUCCESS';
export const FETCH_FEATURE_FLAGS_ERROR = 'app/featureFlags/FETCH_FEATURE_FLAGS_ERROR';

export const UPDATE_FEATURE_FLAGS_REQUEST = 'app/featureFlags/UPDATE_FEATURE_FLAGS_REQUEST';
export const UPDATE_FEATURE_FLAGS_SUCCESS = 'app/featureFlags/UPDATE_FEATURE_FLAGS_SUCCESS';
export const UPDATE_FEATURE_FLAGS_ERROR = 'app/featureFlags/UPDATE_FEATURE_FLAGS_ERROR';

// ================ Reducer ================ //

const DEFAULT_FLAGS = {
  walletGooglePay: false,
  walletApplePay: false,
};

const initialState = {
  flags: DEFAULT_FLAGS,
  fetchInProgress: false,
  fetchError: null,
  updateInProgress: false,
  updateError: null,
  updateSuccess: false,
};

export default function featureFlagsReducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case FETCH_FEATURE_FLAGS_REQUEST:
      return {
        ...state,
        fetchInProgress: true,
        fetchError: null,
      };
    case FETCH_FEATURE_FLAGS_SUCCESS:
      return {
        ...state,
        flags: {
          ...state.flags,
          ...(payload?.featureFlags || {}),
        },
        fetchInProgress: false,
        fetchError: null,
      };
    case FETCH_FEATURE_FLAGS_ERROR:
      return {
        ...state,
        fetchInProgress: false,
        fetchError: payload,
      };

    case UPDATE_FEATURE_FLAGS_REQUEST:
      return {
        ...state,
        updateInProgress: true,
        updateError: null,
        updateSuccess: false,
      };
    case UPDATE_FEATURE_FLAGS_SUCCESS:
      return {
        ...state,
        flags: {
          ...state.flags,
          ...(payload?.featureFlags || {}),
        },
        updateInProgress: false,
        updateError: null,
        updateSuccess: true,
      };
    case UPDATE_FEATURE_FLAGS_ERROR:
      return {
        ...state,
        updateInProgress: false,
        updateError: payload,
        updateSuccess: false,
      };

    default:
      return state;
  }
}

// ================ Action Creators / Thunks ================ //

export const fetchFeatureFlags = ({ refresh = false } = {}) => dispatch => {
  dispatch({ type: FETCH_FEATURE_FLAGS_REQUEST });

  return getFeatureFlagsApi({ refresh })
    .then(response => {
      const featureFlags = response?.featureFlags || DEFAULT_FLAGS;
      dispatch({
        type: FETCH_FEATURE_FLAGS_SUCCESS,
        payload: { featureFlags },
      });
      return featureFlags;
    })
    .catch(error => {
      dispatch({
        type: FETCH_FEATURE_FLAGS_ERROR,
        payload: error,
      });
      return DEFAULT_FLAGS;
    });
};

export const updateFeatureFlags = flags => dispatch => {
  dispatch({ type: UPDATE_FEATURE_FLAGS_REQUEST });

  return updateFeatureFlagsApi(flags)
    .then(response => {
      const updatedFlags = response?.featureFlags || flags;
      dispatch({
        type: UPDATE_FEATURE_FLAGS_SUCCESS,
        payload: { featureFlags: updatedFlags },
      });
      return updatedFlags;
    })
    .catch(error => {
      console.error('[featureFlags.duck] update failed:', error);
      dispatch({
        type: UPDATE_FEATURE_FLAGS_ERROR,
        payload: error,
      });
      throw error;
    });
};
